<div>
  <ng-template #configModal>
    <div class="m-0 p-1 modal-header font-weight-bold" style="background-color: #CFD5EA;">
      View Configuration
      <button type="button" class="close pull-right" aria-label="Close" (click)="closeConfigModal(configComponent)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <fes-table-view-config #configComponent [table]="this" [pagingEnabled]="false"
          (filterKeyUp)="$event.event.key=='Enter'&&closeConfigModal(configComponent)">
      </fes-table-view-config>
    </div>
    <div class="m-0 p-1 modal-footer">
      <button class="btn btn-warning" (click)="closeConfigModal(configComponent)">Close</button>
    </div>
  </ng-template>
  
  <fes-stats-view *ngIf="!isLoading && statsEnabled && statGroupResults?.length" 
    [statGroupResults]="statGroupResults" [tableColumns]="tableColumns">
  </fes-stats-view>
  
  <div class="table-view-table-wrapper">
    <table class="table-view-table table table-striped table-bordered table-sm">
      <thead style="position: sticky; top: -10px; z-index: 1; background-color:#CFD5EA;">
        <tr>
          <th role="button" class="text-center" (click)="toggleAllVisibleExpanded()">
            <i class="fa" [ngClass]="allExpanded?'fa-chevron-down':'fa-chevron-right'"></i>
          </th>
          <th *ngFor="let column of visibleColumns;" role="button" (click)="column.name&&sort(column.name)"
            class="align-middle" [ngClass]="column.headerCellCssClass">
            <div class="d-flex flex-row justify-content-between">
              <div class="w-100 text-center">{{column.title}}</div>
              <i *ngIf="column.name&&sortColumns[0]?.key==column.name" [ngClass]="'fa fa-sort-' + (sortColumns[0]?.order=='ASC'?'up':'down')"></i>
            </div>
          </th>
        </tr>
        <tr>
          <td>
            <div class="d-flex flex-row">
            <i role="button" class="fa fa-filter my-auto px-sm-1"
                (click)="showConfigModal(configModal)" [ngClass]="populatedFilterCnt>0?'text-info':'text-secondary'">
            </i>
            <span role="button" class="fa-stack my-auto px-sm-1" title="Toggle Statistics View"
                (click)="onStatsEnabledClick()">
              <i class="fa fa-chart-bar fa-stack-1x" [ngClass]="!statsEnabled ? 'text-muted':'text-warning'"></i>
              <i *ngIf="statsEnabled" class="fa fa-ban fa-stack-2x" style="opacity: 0.5;"></i>
            </span>
          </div>          
          </td>
          <td *ngFor="let column of visibleColumns;" [ngClass]="column.filterCellCssClass">
            <fes-table-view-filter-input *ngIf="column.filter" [filter]="column.filter"
            (keyUp)="filterKeyUp$.next($event)">
            </fes-table-view-filter-input>
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let record of records;index as index; trackBy:trackByTestId;">
          <tr class="fields-row">
            <td role="button" class="text-center" (click)="toggleExpanded(record)">
              <i class="fa" [ngClass]="expanded[record.testId]?'fa-chevron-down':'fa-chevron-right'"></i>
            </td>
            <td *ngFor="let column of visibleColumns;" [ngSwitch]="column.type">
                <span *ngSwitchCase="'percent'">{{record[column.name]}}%</span>
                <span *ngSwitchCase="'numeric'">{{record[column.name]|number:'0.3'}}</span>
                <span *ngSwitchDefault>{{record[column.name]}}</span>
            </td>
          </tr>
          <tr class="call-component-row" *ngIf="expanded[record.testId]">
            <td [attr.colspan]="visibleColumns.length+1">
                <dialer-voice-call [call]="record.call"></dialer-voice-call>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    </div>
    <div>
  </div>
</div>



